import {
    DataGrid,
    ptBR,
    DataGridProps,
    GridToolbarContainer,
    GridToolbarExport,
    GridToolbarFilterButton,
    GridToolbarColumnsButton,
} from "@mui/x-data-grid";

const styleTableButtons = {
    padding: "5px 10px",
    fontWeight: "600",
    color: "white",
    background: "var(--primary)",
    "&:hover": {
        background: "var(--primary)",
    },
};

const styleExportTableButtons = {
    padding: "5px 10px",
    color: "white",
    fontWeight: "600",
    background: "#107c41",
    "&:hover": {
        background: "#096030",
    },
};

export interface TableDataGrid extends DataGridProps {
    hideExports?: boolean;
    toolBar?: boolean;
    hideColumnMenu?: boolean;
    hideFilter?: boolean;
    disablePadding?: boolean;
    disableBorder?: boolean;
}

function TableDataGrid({
    rows,
    columns,
    onRowClick,
    loading,
    getRowId,
    hideFooterPagination,
    hideExports,
    hideColumnMenu,
    hideFilter = true,
    toolBar = true,
    disablePadding = false,
    disableBorder = false,
    pageSize,
    rowCount,
    ...props
}: TableDataGrid) {
    return (
        <DataGrid
            {...props}
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
            sx={{
                padding: disablePadding ? 0 : "10px",
                // boxShadow: "0px 0px 7px #8888889e",
                borderRadius: 0,
                borderWidth: disableBorder ? 0 : 1,
                background: "#fff",
                ...(props.sx as object),
            }}
            rows={rows}
            columns={columns}
            pageSize={pageSize ?? 10}
            rowsPerPageOptions={pageSize ? [pageSize] : [10]}
            rowCount={rowCount}
            onRowClick={onRowClick}
            hideFooterSelectedRowCount
            hideFooterPagination={hideFooterPagination}
            loading={loading}
            getRowId={getRowId}
            disableColumnMenu
            components={{
                // eslint-disable-next-line react/no-unstable-nested-components
                Toolbar: () => {
                    return toolBar ? (
                        <GridToolbarContainer
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                            className="toolbarContainer"
                        >
                            {!hideColumnMenu && (
                                <GridToolbarColumnsButton
                                    sx={styleTableButtons}
                                />
                            )}
                            {!hideFilter && (
                                <GridToolbarFilterButton
                                    sx={styleTableButtons}
                                />
                            )}
                            {!hideExports && (
                                <GridToolbarExport
                                    sx={styleExportTableButtons}
                                />
                            )}
                        </GridToolbarContainer>
                    ) : (
                        <span />
                    );
                },
            }}
        />
    );
}

export default TableDataGrid;
